<template lang="pug">
section.movements
  h3 Movimientos de inventario temporal
  p(v-if="loading" role="status") Consultando movimientos…
  p(v-if="error" role="alert") No se pudieron consultar los movimientos.
  p(v-if="!rows.length && !loading && !error") Aún no hay entradas ni salidas registradas.
  table(v-if="rows.length")
    thead
      tr
        th Fecha y hora
        th Movimiento
        th Unidades
        th Detalle
    tbody(v-for="row in rows" :key="row._id")
      tr
        td {{ formatDate(row.date) }}
        td {{ row.direction === 'entrada' ? 'Entrada' : 'Salida' }}
        td {{ row.direction === 'entrada' ? '+' : '−' }}{{ row.quantity }}
        td
          shActionButton(
            :action="toggleDetails"
            :params="[row._id]"
            :icon="selected === row._id ? 'visibility_off' : 'visibility'"
            :text="selected === row._id ? 'Ocultar detalles' : 'Ver detalles'"
          )
      tr(v-if="selected === row._id")
        td(colspan="4")
          .items
            InventoryProduct(v-for="(item, index) in row.items" :key="index" :reference="item.product" :size="item.size" :quantity="item.quantity" :brand="item.brand || ''" :folder="item.folder || ''" :subfolder="item.subfolder || ''" :image="item.image")
  button(v-if="hasMore" type="button" @click="load(true)" :disabled="loading") Ver movimientos anteriores
</template>

<script>
import gql from '@my/graphql'
import shActionButton from '@/components/elements/ActionButton'
import InventoryProduct from '../inventory/edit/Product'

const query = `query temporaryStockMovements($before: ID) {
  getTemporaryStockMovements(before: $before) {
    _id date direction quantity
    items { product size quantity image folder subfolder brand }
  }
}`

export default {
  components: { InventoryProduct, shActionButton },
  data () {
    return { loading: false, error: false, rows: [], selected: null, hasMore: false }
  },
  created () {
    this.load(false)
  },
  methods: {
    toggleDetails (id) {
      this.selected = this.selected === id ? null : id
    },
    formatDate (date) {
      return new Date(date).toLocaleString('es-CO', { timeZone: 'America/Bogota' })
    },
    async load (append) {
      if (this.loading) return
      this.loading = true
      this.error = false
      try {
        const before = append ? this.rows[this.rows.length - 1]._id : null
        const result = await gql.query(query, { before }, false)
        const rows = result.data.getTemporaryStockMovements
        this.rows = append ? this.rows.concat(rows) : rows
        this.hasMore = rows.length === 25
      } catch (error) {
        this.error = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.movements { margin: 1rem 0; overflow-x: auto; }
table { width: 100%; border-collapse: collapse; margin: 1rem 0; }
td, th { text-align: left; padding: .5rem; border-bottom: 1px solid #ddd; }
.items { display: grid; grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr)); gap: 1rem; }
</style>



// WEBPACK FOOTER //
// src/components/pages/temporaryStock/Movements.vue